import { render, staticRenderFns } from "./ModalCadastroSubFaseExecucao.vue?vue&type=template&id=6f9be828"
import script from "./ModalCadastroSubFaseExecucao.vue?vue&type=script&lang=js"
export * from "./ModalCadastroSubFaseExecucao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports